import Vue from 'vue'
import Router from 'vue-router'
import Store from '../store'
import Home from '../components/Home'
import Register from '../components/user/Register'
import Terms from '../components/Terms'
import Deposit from '../components/payments/Deposit'
import Login from '../components/user/Login'
import Bonuses from '../components/main/Bonuses'
import Withdraw from '../components/payments/Withdraw'
import Account from '../components/user/Account'
import LaunchGame from '../components/games/LaunchGame'
import LaunchGameMobile from '../components/games/LaunchGameMobile'
import ForgotPassword from '../components/user/actions/ForgotPassword'
import UserLevels from "../components/main/UserLevels";
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      props: true,
      component: Home,
      meta: {
        title: 'Главная'
      }
    },
    {
      name: 'registration',
      path: '/registration',
      props: true,
      component: Register,
        meta: {
            title: 'Регистрация'
        }
    },
    {
      name: 'terms',
      path: '/terms',
      props: true,
      component: Terms,
        meta: {
            title: 'Условия'
        }
    },
    {
      name: 'deposit',
      path: '/deposit',
      props: true,
      component: Deposit,
        meta: {
            title: 'Депозит'
        }
    },
    {
      name: 'withdraw',
      path: '/payout',
      props: true,
      component: Withdraw,
        meta: {
            title: 'Выплаты'
        }
    },

    {
      name: 'login',
      path: '/signin',
      props: true,
      component: Login,
        meta: {
            title: 'Авторизация'
        }
    },
    {
      name: 'bonuses',
      path: '/bonuses',
      props: true,
      component: Bonuses,
        meta: {
            title: 'Бонусы'
        }
    },
    {
      name: 'UserLevels',
      path: '/Levels',
      props: true,
      component: UserLevels,
      meta: {
        title: 'Уровни игроков'
      }
    },
    {
      name: 'account',
      path: '/account/:placeName',
      props: true,
      component: Account,
        meta: {
            title: 'Аккаунт'
        }
    },
    {
      name: 'LaunchGame',
      path: '/Game/:gameName',
      props: true,
      component: LaunchGame,
      beforeEnter: (to, from, next) => {
        if (Store.getters.userData === null || typeof Store.getters.userData === 'undefined') {
          Store.dispatch('fetchUserData').then((resp) => {
            if (resp.userData) {
              return next()
            }
            return next('/signin')
          })
        }
        return next()
      }
    },
    {
      name: 'LaunchGameMobile',
      path: '/Game/:gameName',
      props: true,
      component: LaunchGameMobile,
      beforeEnter: (to, from, next) => {
        if (Store.getters.userData === null || typeof Store.getters.userData === 'undefined') {
          Store.dispatch('fetchUserData').then((resp) => {
            if (resp.userData) {
              return next()
            }
            return next('/signin')
          })
        }
        return next()
      }
    },
    {
      name: 'recover',
      path: '/recover-account',
      props: true,
      component: ForgotPassword
    }
  ]
})
